import { render, staticRenderFns } from "./WBtnReload.vue?vue&type=template&id=23fb6abd&scoped=true&"
import script from "./WBtnReload.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnReload.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fb6abd",
  null
  
)

export default component.exports